import { motion } from "motion/react"

export const div = motion.div;
export const button = motion.button;